<template>
   <v-icon v-if="item.is_cancelled===1" left class="ma-0 pa-0">mdi-cancel</v-icon>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
}
</script>